import { formatOneDigitNumber, weightAverageByMileage } from '@utils/formatters';

import createColumn from './createColumn';

export const weightSignal = {
    format: formatOneDigitNumber,
    average: weightAverageByMileage,
    unit: 'averageWeight',
};

export const weightSignalInKg = {
    format: formatOneDigitNumber,
    average: weightAverageByMileage,
    unit: 'co2Emission',
};

export const averageWeight = createColumn({
    key: 'averageWeight',
    dataField: 'averageWeight',
    labelId: 'averageWeight',
    formatter: weightSignal.format,
});

export const co2Emission = createColumn({
    key: 'co2Emission',
    dataField: 'co2Emission',
    labelId: 'co2Emission',
    formatter: weightSignalInKg.format,
});
